module.exports = {
	API_URL: "https://invisibles.xyz", //"https://207.154.197.250:1337",
	PUBLIC_URL: "https://neurocure-brainjourney.de",
	DEV_URL: "https://192.168.86.25:8080",
	development: false,
};
